import { round, roundUp } from "../utils";

type Props = {
  quantity: number;
  reworkRatio: number;
};

export const computeNeededQuantity = ({ quantity, reworkRatio }: Props) => {
  const sanitizedReworkRatio = reworkRatio || 0;

  const neededQuantity = roundUp(round(quantity * (1 + sanitizedReworkRatio / 100), 8));

  return neededQuantity;
};
